export const ESTADOS = {
    Aprobado: { color: "success", label: "Aprobado", margin: 2 },
    Rechazado: { color: "error", label: "Rechazado", margin: 2 },
    Pendiente: { color: "uproYellow", label: "Pendiente de aprobación", margin: 0 },
    SinFacturar: { color: "uproPink", label: "Sin Facturar", margin: 2 },
    OPEmitida: { color: "info", label: "Orden de Pago Emitida", margin: 0 },
    OPFinalizada: { color: "uproGreen", label: "Orden de Pago Finalizada", margin: 0 },
}